// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchHeaderControls_wrapper__0eHO3","link":"SearchHeaderControls_link__0rOiu"};